import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Plus, Minus, ArrowLeft, ArrowRight, Check, ShoppingCart, Calculator,
  Trash2, MapPin, ExternalLink, Package, X,
} from 'lucide-react';
import {
  FLOOR_PREP_PRODUCTS,
  EPOXY_PRIMERS,
  HIGH_BUILD_EPOXY,
  FLAKE_PRODUCTS,
  POLYASPARTIC_SEAL,
  HIGH_BUILD_SYSTEMS,
  FLAKE_COVERAGE,
  HIGH_BUILD_COLOUR_CHART,
} from '@/components/proepoxy/productData';
import { calculateOptimalPacks } from '@/components/proepoxy/utils';
import { submitProEpoxyOrder } from '@/components/proepoxy/submitOrder';
import PrioritySelector from '@/components/PrioritySelector';

import HighBuildGuidedStep1 from '@/components/proepoxy/highbuild-flow/HighBuildGuidedStep1';
import HighBuildGuidedStep2 from '@/components/proepoxy/highbuild-flow/HighBuildGuidedStep2';
import HighBuildGuidedStep3 from '@/components/proepoxy/highbuild-flow/HighBuildGuidedStep3';
import HighBuildGuidedStep4 from '@/components/proepoxy/highbuild-flow/HighBuildGuidedStep4';
import HighBuildGuidedStep5 from '@/components/proepoxy/highbuild-flow/HighBuildGuidedStep5';

export default function HighBuildGuidedFlow({ state, priority, setPriority, currentStep, goToStep, highBuildOrderMode, setHighBuildOrderMode, navigate, onExit, voucher }) {
  const {
    highBuildAreas, manualOrder,
    showInstallationGuide, setShowInstallationGuide,
    showColourChart, setShowColourChart,
    highBuildSteps,
    addHighBuildArea, removeHighBuildArea, updateHighBuildArea,
    initializeHighBuildProducts,
    calculateHighBuildTotal, getHighBuildItemCount,
    addPrimerItem, updatePrimerItem, removePrimerItem,
    addHighBuildItem, updateHighBuildItem, removeHighBuildItem,
    addFlakeItem, updateFlakeItem, removeFlakeItem,
    updateManualOrder, setManualOrder,
    calculateManualOrderTotal, getManualOrderItemCount,
    updateManualFloorPrepQty,
  } = state;
  const stepProps = { state, priority, setPriority, currentStep, goToStep, highBuildOrderMode, setHighBuildOrderMode, navigate, onExit, voucher };
  return (
    <>
                {/* Progress Indicator */}
                <div className="bg-white rounded-2xl shadow-sm p-4 mb-6">
                  <div className="flex items-center justify-between mb-3">
                    <h2 className="font-bold text-[#27292E]">High Build Epoxy</h2>
                    <span className="text-sm text-gray-500">Step {currentStep} of 5</span>
                  </div>
                  <div className="flex">
                    {highBuildSteps.map(step => (
                      <button 
                        key={step.num} 
                        className="flex-1 flex flex-col items-center min-w-0"
                        onClick={() => goToStep(step.num)}
                      >
                        <div 
                          className={`w-full h-2 rounded-full transition-all mx-0.5 ${
                            step.num <= currentStep ? 'bg-[#7A0B7A]' : 'bg-gray-200'
                          }`}
                        />
                        <p className={`text-[9px] sm:text-xs mt-1 text-center cursor-pointer hover:text-[#7A0B7A] transition-colors truncate w-full px-0.5 ${
                          step.num === currentStep ? 'text-[#7A0B7A] font-medium' : 'text-gray-400'
                        }`}>
                          {step.title}
                        </p>
                      </button>
                    ))}
                  </div>
                </div>


      {currentStep === 1 && <HighBuildGuidedStep1 {...stepProps} />}
      {currentStep === 2 && <HighBuildGuidedStep2 {...stepProps} />}
      {currentStep === 3 && <HighBuildGuidedStep3 {...stepProps} />}
      {currentStep === 4 && <HighBuildGuidedStep4 {...stepProps} />}
      {currentStep === 5 && <HighBuildGuidedStep5 {...stepProps} />}
    </>
  );
}
